import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function changePassword(data: {
  CURRENT_PASSWORD: string;
  PASSWORD: string;
  CONFIRM_PASSWORD: string;
}) {
  const res = await ApiClient.post(`/ChangePassword`, data);
  return res.data;
}

export const useChangePassword = mutationWrapper(changePassword);
